import { IReduxAction } from './index'
import { REHYDRATE } from 'redux-persist'
import { AppAction } from '../config/appConfig'

export default function reducer(state: string = null, action: IReduxAction): string {
    switch (action.type) {
        case REHYDRATE:
            return action.payload?.page || null

        case AppAction.SetCurrentPage:
            return action.payload
    }

    return state
}
